import { toastController } from '@ionic/vue';

export class ToastUtils {

    async presentToast(message: any) {
        const toast = await toastController.create({
            message: message,
            duration: 3800,
            // position: 'middle',
          });
          await toast.present();

        //   Comment for migration work
        // const toast = document.createElement('ion-toast');
        // toast.message = message;
        // // toast.trigger="open-toast";
        // // toast.position = 'middle';
        // toast.duration = 5000;

        // document.body.appendChild(toast);
        // return await toast.present();
    }

    async errorTimeHandlingToast(message: any) {
        const toast = await toastController.create({
            message: message,
            duration: 100000,
            // position: 'middle',
          });
          await toast.present();
    }

    async presentToastDialog(message: any) {
        const toast = document.createElement('ion-toast');
        toast.message = message;
        toast.position = 'middle';
        toast.buttons = [
            {
                text: 'OK',
                role: 'cancel',
                handler: () => {
                    console.log('Cancel clicked');
                }
            }
        ];

        document.body.appendChild(toast);
        return toast.present();
    }

    async presentToastWithOptions() {
        const toast = document.createElement('ion-toast');
        toast.header = 'Toast header';
        toast.message = 'Click to Close';
        toast.position = 'top';
        toast.buttons = [
            {
                side: 'start',
                icon: 'star',
                text: 'Favorite',
                handler: () => {
                    console.log('Favorite clicked');
                }
            }, {
                text: 'Done',
                role: 'cancel',
                handler: () => {
                    console.log('Cancel clicked');
                }
            }
        ];

        document.body.appendChild(toast);
        return toast.present();
    }
}